var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_857_78)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_857_78",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 32,
    height: 32
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_857_78)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.77344 0H8.2161V1.42533H9.5361V0H10.9788V4.31467H9.5361V2.87067H8.2161V4.31467H6.77477L6.77344 0ZM12.8748 1.43067H11.6054V0H15.5881V1.43067H14.3174V4.31467H12.8748V1.43067ZM16.2201 0H17.7241L18.6494 1.516L19.5734 0H21.0774V4.31467H19.6414V2.176L18.6494 3.71067H18.6241L17.6308 2.17733V4.31467H16.2201V0ZM21.7948 0H23.2388V2.88933H25.2654V4.316H21.7948V0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.728 29.4293L4 6.28934H28L25.2707 29.4267L15.9867 32L6.728 29.4293ZM12.244 16.7627L11.9853 13.856H22.8453L23.0987 11.0187H8.88533L9.65067 19.6013H19.4867L19.1573 23.2813L15.992 24.1373H15.9893L12.8293 23.284L12.6267 21.0213H9.776L10.1733 25.4773L15.9867 27.0907L21.8093 25.4773L22.5187 17.5253L22.588 16.764L12.244 16.7627Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_857_78"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHtml);
export default __webpack_public_path__ + "static/media/icon_html.5a1079413c4714011a606cbfa78d943a.svg";
export { ForwardRef as ReactComponent };